import React from 'react';
import {ChartDataProvider} from './context/ChartDataContext';
import StepOrgData, {STEP} from './StepOrgData';

export {STEP};
export default function Page() {
  return (
    <ChartDataProvider>
      <StepOrgData />
    </ChartDataProvider>
  );
}
